package com.patronat.top.features.venues.domain.usecase

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.VenueDraftResponse
import com.patronat.top.features.venues.domain.repository.VenuesRepository
import com.patronat.top.features.venues.domain.usecase.command.GetSubmittedVenueDraftCommand

class GetSubmittedVenueDraftUseCase(
    private val venuesRepository: VenuesRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<GetSubmittedVenueDraftCommand, DomainResult<VenueDraftResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: GetSubmittedVenueDraftCommand): DomainResult<VenueDraftResponse> {
        return venuesRepository.getSubmittedVenueDraft(command.venueId)
    }
}
